import { all, put, call, takeEvery, takeLatest } from "redux-saga/effects";
import api_service from "../../network/api_callbacks";
import {
    SIGN_IN_REQUEST,
    signInSuccess,
    signInFailure,
    SIGN_OUT
} from "../actions/signIn"
import storage, { LS_LOGIN } from "../../storage/storage";
import categoriesData from "../../assets/json/categories3.json";
import { BASE_URL_2 } from "../../network/constants";

function* signInSaga(action) {
    try {
        const { rememberMe, ...credentials } = action.payload;
        const response = yield call(api_service.signIn, credentials);
        if (response && response?.status === 200) {
            const { token, user_id, role, displayName, } = response.data;
           // const expiryTime = new Date().getTime() + 24 * 60 * 60 * 1000; // ms
            const authData = {
                token,
                user_id,
                role,
                displayName,
                //expiryTime,
            };
            storage.set(LS_LOGIN, authData);
            yield put(signInSuccess(response?.data));
        }
        else{
            yield put(signInFailure('Invalid credentials'));
        }
    } catch (err) {
        console.log(err);
        yield put(signInFailure(err.response?.data?.message || 'Sign-in failed'));
    }
}

function* signOutSaga(action) {
    try {
        storage.remove(LS_LOGIN);
        storage.clear();
    }
    catch (err) {
        console.log(err);
    }
}

export default function* watchSignInSaga() {
    yield all([
        takeLatest(SIGN_IN_REQUEST, signInSaga),
        takeEvery(SIGN_OUT, signOutSaga),
      ]);
}
